import './style.css'

export default {
    data () {
        return {}
    },
    render (h) {
        return (
            <div id='app'>
                <router-view></router-view>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/App/index.js